import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import animationData from '../image/loading.json';

const useStyles = makeStyles({
  emptyStates: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
    // padding: '25% 0'
  }
});

export default function EmptyDashboard({ text }) {
  const classes = useStyles();
  return (
    <div className={classes.emptyStates}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData
        }}
        height={150}
        width={250}
        style={{ marginTop: '-30px', marginBottom: '-20px', cursor: 'default' }}
        isClickToPauseDisabled
      />
      <Typography variant="subtitle1" noWrap>
        {text || 'No Data Available'}
      </Typography>
    </div>
  );
}

EmptyDashboard.propTypes = {
  text: PropTypes.string
};
